import React from 'react';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';

import { Icon } from '../../icons';
import { Badge } from '../../badges/Badge';

type Props = {
  ariaHidden: boolean,
};

export const CheckBadge = ({ ariaHidden = true }: Props) => {
  const theme = useTheme();

  return (
    <BadgeWrapper type="brand" aria-hidden={ariaHidden}>
      <Icon name="Check" fill={theme.color.white} ariaHidden={ariaHidden} />
    </BadgeWrapper>
  );
};

const BadgeWrapper = styled(Badge)`
  display: inline-flex;
  height: 32px;
  width: 32px;
  font-size: ${({ theme }) => theme.fontSize.md};
  justify-content: center;
  align-items: center;

  @media (${({ theme }) => theme.breakpoint.tablet}) {
    height: 40px;
    width: 40px;
  }

  @media (${({ theme }) => theme.breakpoint.kiosk}) {
    width: 48px;
    height: 48px;
  }
`;
